import React from 'react';
import { useNavigate } from "react-router-dom";
import { Navbar, Button, Container } from 'react-bootstrap';

const Header = () => {
  const navigate = useNavigate();

  const cooperative = JSON.parse(localStorage.getItem("cooperative"));
  const name = cooperative.name || 'Restrito';

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="lg"
      style={{
        borderBottom: '1px solid rgba(148, 163, 184, 0.35)',
        background: 'rgba(15, 23, 42, 0.95)',
        backdropFilter: 'blur(8px)',
        height: 56
      }}
    >
      <Container fluid>
        <Navbar.Brand className="fw-semibold">
          {name}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Button
            variant="outline-light"
            size="sm"
            onClick={handleLogout}
            className="ms-auto px-3"
          >
            Sair
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
